const parseValue = (value) => {
  const parsedValue = !!value ? `${value}`.split(',') : [];
  return parsedValue;
};

export default parseValue;
